import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { useMutation } from '@tanstack/react-query';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import WhitePlus from '@/assets/icons/admin/white_plus.svg?react';
import { motion } from 'motion/react';

export function ConnectNewAccount() {
  const { apiFetch } = useOpenApiClient();
  const plaidHostedLinkMutation = useMutation({
    mutationFn: () => apiFetch.POST(`/plaid/link`),
    onSuccess: (data) => {
      if (!data.data?.data?.hosted_link_url) {
        return;
      }
      window.location.href = data.data?.data?.hosted_link_url;
    },
  });
  return (
    <motion.div
      className={cn(
        'flex w-[calc(100vw-3rem)] max-w-[338px] cursor-pointer items-center gap-2',
        'rounded-[62px_0px_0px_62px] border-r-0 border-none bg-white/65 px-2 py-1 pr-0 shadow-[4px_-2px_0px_rgba(255,255,255,0.64)]',
        {
          'cursor-progress opacity-50': plaidHostedLinkMutation.isPending,
        },
      )}
      initial={{ x: 100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.7, ease: 'anticipate' }}
      onClick={() => plaidHostedLinkMutation.mutate()}
    >
      <span
        className={cn(
          'bg-secondary-light flex h-16 w-16 items-center justify-center rounded-full p-1 lowercase',
        )}
      >
        <WhitePlus />
      </span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <p className="text-foreground text-xl leading-10 font-extralight">Connect an account</p>
          </TooltipTrigger>
          <TooltipContent>Connect a new account</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </motion.div>
  );
}
